import { Link } from "@tanstack/react-router";
import { Gift, Info } from "lucide-react";

import { isFreeMessagesOfferAdvertised } from "@mandoob/shared";

import { useLanguage } from "@/contexts/language";
import { cn } from "@/lib/utils";

/**
 * Free-messages offer strip. Shown from the moment it ships until the offer
 * ends, so it can sit permanently in the home and landing pages. The only
 * way to the terms page is the small info icon at its end — deliberately
 * low-key.
 */
export function OfferBanner({
  variant,
  className,
}: {
  /** "landing": full-bleed bar across the page top. "app": rounded card. */
  variant: "landing" | "app";
  className?: string;
}) {
  const { t } = useLanguage();
  if (!isFreeMessagesOfferAdvertised()) return null;

  return (
    <div
      className={cn(
        "tw:flex tw:items-center tw:gap-2.5 tw:bg-linear-to-r tw:from-brand tw:to-brand-600 tw:text-brand-foreground",
        variant === "landing"
          ? "tw:justify-center tw:px-4 tw:py-2.5 tw:text-center tw:text-sm tw:font-medium"
          : "tw:rounded-2xl tw:px-4 tw:py-3 tw:text-sm tw:font-medium tw:shadow-sm",
        className,
      )}
    >
      <Gift className="tw:size-5 tw:shrink-0" strokeWidth={2.25} />
      <span className={cn(variant === "app" && "tw:min-w-0 tw:flex-1")}>
        {t("Mandoob:Offer.Banner")}
      </span>
      <Link
        to="/offer-terms"
        aria-label={t("Mandoob:Offer.Terms")}
        title={t("Mandoob:Offer.Terms")}
        className="tw:flex tw:size-6 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:text-brand-foreground/80 tw:no-underline tw:hover:bg-white/15 tw:hover:text-brand-foreground"
      >
        <Info className="tw:size-4" strokeWidth={2} />
      </Link>
    </div>
  );
}
